 export default {
  methods: {
    harf_b(gelen){
      var sonuc
      var specialLetters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      sonuc = gelen.replace(/(([iışğüçö]))/g, function (letter) { return specialLetters[letter]; });
      return sonuc.toUpperCase();
  },
  harf_k(gelen){
      var sonuc
      var specialLetters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
      sonuc = gelen.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) { return specialLetters[letter]; });
      return sonuc.toLowerCase();
  },
  harf_bhb(gelen){
      var specialLetters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      var letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
      var arr = gelen.split(' ');
      for (var i = 0; i < arr.length; i++) {
          arr[i] = arr[i].charAt(0).replace(/(([iışğüçö]))/g, function (letter) { return specialLetters[letter]; }).toUpperCase() + arr[i].substr(1).replace(/(([İIŞĞÜÇÖ]))/g, function (letter) { return letters[letter]; }).toLowerCase();
      }
      return arr.join(" ");
  },
   tel_format:function(phoneNumberString) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(90|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (match) {
      let intlCode = (match[1] ? '+90 ' : '');
      return [intlCode, match[2], ' ', match[3], ' ', match[4], ' ', match[5]].join('');
    }
    return null;
  },
  tel_formatla:function(gelen){
    //var x = gelen.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    return "+90"+gelen

  }
  },
};